import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TextField } from 'redux-form-material-ui'

// styles

const defaultStyles = {
    input: {
        color: '#606060',
    },
    underline: {
        borderColor: '#909090',
    },
    underlineFocus: {
        borderColor: '#2580AC',
    },
    floatingLabel: {
        color: '#606060',
    },
    floatingLabelFocus: {
        color: '#2580AC',
    },
}

const lightStyles = {
    input: {
        color: 'white',
    },
    underline: {
        borderColor: 'rgba(255,255,255,0.5)',
    },
    underlineFocus: {
        borderColor: 'white',
    },
    floatingLabel: {
        color: 'white',
    },
    floatingLabelFocus: {
        color: 'rgba(255,255,255,0.5)',
    },
}

// component

class RFTextField extends Component {
    render() {
        const styles = this.props.theme === 'light' ? lightStyles : defaultStyles

        return <TextField
            {...this.props}
            inputStyle={styles.input}
            underlineStyle={styles.underline}
            underlineFocusStyle={styles.underlineFocus}
            floatingLabelStyle={styles.floatingLabel}
            floatingLabelFocusStyle={styles.floatingLabelFocus}
        />
    }
}

RFTextField.propTypes = {
    theme: PropTypes.string,
}

export default RFTextField
